import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef, EventEmitter, Output, Input } from '@angular/core';
import {MatPaginator, MatSort} from '@angular/material';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { of as observableOf} from 'rxjs/observable/of';
import {debounceTime, distinctUntilChanged, startWith, tap, delay} from 'rxjs/operators';
import {catchError, map, switchMap} from 'rxjs/operators';
import {merge} from 'rxjs/observable/merge';
import {fromEvent} from 'rxjs/observable/fromEvent';

import {VehicleGroupDataSource} from './schedule-types.datasource';

import { PaginationParams } from '../../../_models/generic';
import { VehiclesFilesService } from 'app/_services/vehicles-files.service';
import { IScheduleType } from 'app/_models/schedule-activity';


@Component({
  selector: 'app-dl-multi-select-schedule-types',
  templateUrl: './dl-multi-select-schedule-types.component.html',
  styleUrls: ['./dl-multi-select-schedule-types.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DlMultiSelectScheduleTypeComponent implements OnInit {

  dataSource: VehicleGroupDataSource;
  displayedColumns: string[] = ['name', 'category', 'id'];
  public defaultPageSize: number = 50;
  public pageDisplayOptions: Array<number> = [25, 50, 75, 100];

  @Input() selectedGroups: Array<IScheduleType>;
  @Input() labelText: string;
  @Output() outputSelectedVehicles = new EventEmitter<Array<IScheduleType>>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('multiSelectVGSearch') tableSearchInput: ElementRef;

  constructor(private vehiclegroupService: VehiclesFilesService) { }

  ngOnInit() {
    // Create new instance of datasource
    this.dataSource = new VehicleGroupDataSource(this.vehiclegroupService);
    // Get first page of data
    this.loadInitialVehicles();
  }

  ngAfterViewInit() {

    // server-side search
    fromEvent(this.tableSearchInput.nativeElement, 'keyup')
        .pipe(
            debounceTime(150),
            distinctUntilChanged(),
            tap(() => {
                this.paginator.pageIndex = 0;
                this.loadVehiclePage();
            })
        )
        .subscribe();

    // reset the paginator after sorting
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    // on sort or paginate events, load a new page
    merge(this.sort.sortChange, this.paginator.page)
    .pipe(
        tap(() => this.loadVehiclePage())
    )
    .subscribe();
  }

  public selectItem(item: IScheduleType) {
    if ( this.isRowSelected(item.id) ) {
      return false;
    } else {
      this.selectedGroups.push(item);
      this.outputSelectedVehicles.emit(this.selectedGroups);
    }
  }

  public deSelectItem(index: number, item: IScheduleType) {
    this.selectedGroups.splice(index, 1);
    this.outputSelectedVehicles.emit(this.selectedGroups);
  }
  public clearAllSelected() {
    this.selectedGroups = [];
    this.outputSelectedVehicles.emit(this.selectedGroups);
  }

  public isRowSelected(id: number) {
    const _found = this.selectedGroups.some(function (el) {
      return el.id === id;
    });
    if (_found) {
      return true;
    }
    return false;
  }

  private clearTableSearch() {
    this.tableSearchInput.nativeElement.value = '';
    this.loadVehiclePage();
  }

  private loadInitialVehicles() {
    const _params: PaginationParams = {
      pageSize: this.defaultPageSize,
      page: 1,
      orderingDirection: '',
      ordering: 'name',
      search: ''
    };
    this.dataSource.loadAdminVehicles(_params);
  }

  private loadVehiclePage() {
    const _params: PaginationParams = {
      pageSize: this.paginator.pageSize,
      page: this.paginator.pageIndex + 1,
      orderingDirection: this.sort.direction,
      ordering:  this.sort.active,
      search: this.tableSearchInput.nativeElement.value
    };
    this.dataSource.loadAdminVehicles(_params);
  }


}






// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/shared/components/dl-multi-select-schedule-types/dl-multi-select-schedule-types.component.ts